import { useCallback, useMemo, useRef } from "react";
import { VirtualListRef } from "@/component/VirtualList";


export const useScrollControl = <T extends {id: number}>(items: T[], virtualListRef: React.RefObject<VirtualListRef>) => {
    const autoScrollIdRef = useRef<number>();

    const setAutoScrollId = useCallback((itemId: number) => {
        autoScrollIdRef.current = itemId;
    }, []);

    const scrollTo = useCallback((targetId?: number) => {
        if (!targetId || !virtualListRef.current) {
            return;
        }
        const index = items.findIndex(items => items.id === targetId);
        if (index === -1) {
            return;
        }

        if (autoScrollIdRef.current === targetId) {
            virtualListRef.current.scrollTo(index);
            autoScrollIdRef.current = undefined;
        } else {
            virtualListRef.current.scrollTo(index, 'center');
        }
    }, [items, virtualListRef]);

    return useMemo(() => {
        return {
            setAutoScrollId,
            scrollTo
        };
    }, [setAutoScrollId, scrollTo]);
};
